import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, Directive, Input, QueryList, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ownedError } from 'core/utils/owned-error';
import { MdePopover } from 'shared/modules/material/popover/popover.module';

@Directive({
  selector: '[app-popover-close]',
  standalone: false,
})
export class PopoverCloseDirective {
  get button(): MatButton {
    return this._button!;
  }

  constructor(private _button?: MatButton) {
    if (!_button) {
      throw ownedError(new Error('Button is not provided'));
    }
  }
}

@Component({
  selector: 'app-popover-button',
  templateUrl: './popover-button.component.html',
  styleUrls: ['./popover-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PopoverButtonComponent implements AfterContentInit {
  @Input() text?: string;
  @Input() icon?: string;
  @Input() color: 'primary' | 'warn' = 'primary';
  @Input() type?: 'stroked' | 'raised' | 'icon';
  @Input() disabled = false;

  @ViewChild(MdePopover)
  popover!: MdePopover;

  @ContentChildren(PopoverCloseDirective)
  closeButtons!: QueryList<PopoverCloseDirective>;

  constructor() {
  }

  ngAfterContentInit(): void {
    this.closeButtons!.forEach((b) => {
      const events = b.button._elementRef.nativeElement as GlobalEventHandlers;
      events.onclick = () => this.popover.close.emit();
    });
  }
}
